// The start/stop control plus the session's state at a glance. The ring pulses
// while the coach is speaking so it's obvious when to wait and when to talk.

const LABELS = {
  idle: 'Start speaking',
  connecting: 'Connecting…',
  listening: 'Listening — just talk',
  speaking: 'Coach is speaking',
  error: 'Something went wrong',
};

const TONES = {
  idle: 'bg-sky-600 hover:bg-sky-500 text-white',
  connecting: 'bg-slate-700 text-slate-300',
  listening: 'bg-emerald-600 text-white',
  speaking: 'bg-indigo-600 text-white',
  error: 'bg-rose-700 text-white',
};

function mmss(total) {
  const m = String(Math.floor(total / 60)).padStart(2, '0');
  const s = String(total % 60).padStart(2, '0');
  return `${m}:${s}`;
}

export default function MicOrb({ status, active, elapsed, onStart, onStop, onFinish, disabled }) {
  return (
    <div className="flex items-center gap-4">
      <button
        type="button"
        onClick={active ? onStop : onStart}
        disabled={disabled && !active}
        className={`relative flex h-16 w-16 items-center justify-center rounded-full text-2xl transition ${
          TONES[status] || TONES.idle
        } ${status === 'speaking' ? 'pulse-ring' : ''} ${
          disabled && !active ? 'cursor-not-allowed opacity-40' : ''
        }`}
        title={
          disabled && !active
            ? 'No story loaded'
            : active
              ? 'Stop the session'
              : 'Start the session'
        }
      >
        {active ? '■' : '●'}
      </button>

      <div className="min-w-0">
        <div className="text-sm font-medium text-slate-200">{LABELS[status]}</div>
        <div className="mt-0.5 text-xs tabular-nums text-slate-500">
          {active ? mmss(elapsed) : 'Mic off'}
        </div>
      </div>

      {active && (
        <button
          type="button"
          onClick={onFinish}
          className="ml-auto rounded-lg border border-slate-700 px-3 py-1.5 text-xs text-slate-300 hover:bg-slate-800"
        >
          Finish &amp; recap
        </button>
      )}
    </div>
  );
}
